import { Circle, HStack, Text } from "@chakra-ui/react";
import { UserFragment, UserStatusType } from "gql/graphql";
import React, { memo } from "react";
import colors from "app/colors";
import moment from "moment";
import { MESSAGE_THREAD_DATE_SEPERATOR_FORMAT } from "modules/utils/Constants";
import { useUserPresence } from "modules/providers/user-presence-provider";

interface IProps {
  user: UserFragment;
}

const UserOnlineStatus = ({ user }: IProps) => {
  const { getUserStatusType } = useUserPresence();

  if (getUserStatusType(user.id) === UserStatusType.Online) {
    return (
      <HStack w="full" spacing={1}>
        <Circle backgroundColor={colors.greenPrimary} size={3} m={1} />
        <Text fontSize={12} fontWeight={500} color={colors.grayMain}>
          Online Now
        </Text>
      </HStack>
    );
  }

  if (user.checkInTime) {
    return (
      <HStack w="full" spacing={1}>
        <Circle backgroundColor={colors.gray30} size={3} m={1} />
        <Text
          fontSize={12}
          fontWeight={500}
          color={colors.grayMain}
        >{`Last Online ${moment(user.checkInTime).calendar(
          MESSAGE_THREAD_DATE_SEPERATOR_FORMAT,
        )}`}</Text>
      </HStack>
    );
  }

  return (
    <HStack w="full" spacing={1}>
      <Circle backgroundColor={colors.red} size={3} m={1} />
      <Text fontSize={12} fontWeight={500} color={colors.grayMain}>
        Never Logged In
      </Text>
    </HStack>
  );
};

export default memo(UserOnlineStatus);
